import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useAuthUserData from "./useAuthUserData";
import { FR_ROLE } from "../utils/constants";
interface AuthGuardOptions {
  allowedRoles: string[];
  redirectTo?: string;
}

const useAuthGuard = ({ allowedRoles }: AuthGuardOptions) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useAuthUserData();

  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate("/", {
          state: `${location.pathname}${location.search}`,
        });
      } else if (!allowedRoles.includes(user.rol)) {
        user.rol === FR_ROLE.FIRST_RESPONDER_USER
          ? navigate("/SearchSubscriber")
          : navigate("/admin/manageUsers");
      }
    }
  }, [user, loading, allowedRoles]);
};

export default useAuthGuard;
